import { prop } from "../../decorators/property";
import { StatuteOutlineModel } from "../../desktop/models/statute-outline";
import { Container } from "aurelia-dependency-injection";
import { AuthService } from "../../authentication/auth-service";
import { AppUser } from "../../authentication/app-user";
import { ContainerHelper } from "../../shared/helpers/container-helper";

export class ExactResultModel extends Backbone.AssociatedModel {

    @prop() public ShortTitle: string;
    @prop() public Summary: string;
    @prop() public Url: string;
    @prop() public Id: string;
    @prop() public TruncatedSummary: string;
    @prop() public ShortSummary: string;
    @prop() public DocTypeString: string;
    @prop() public CelexNumber: string;
    @prop() public CellarId: string;
    @prop() public ECLI: string;
    @prop() public Outline: StatuteOutlineModel;

    private user: AppUser;

    constructor(options?) {
        super(options);
        this.user = ContainerHelper.AuthService.AppUser;
        if (this.Outline) {
            this.checkForCommencementsFeatureFlag();
        }
    }

    private checkForCommencementsFeatureFlag() {
        const hasCommencementsFlag = this.user.hasFeatureFlag("CommencementOrders");
        if (!hasCommencementsFlag) {
            this.Outline.HasCommencements = false;
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/exact-result.ts